import React, { useState } from "react";
import mpc from "../assets/rankridgecollegewebsiteimages 01/mpc1.webp"
import mpc2 from "../assets/rankridgecollegewebsiteimages 01/mpc2.webp"
import mpc3 from "../assets/rankridgecollegewebsiteimages 01/about1.webp"
import mpc4 from "../assets/rankridgecollegewebsiteimages 01/about2.webp"
import mpc5 from "../assets/rankridgecollegewebsiteimages 01/about3.webp"
import mpc6 from "../assets/rankridgecollegewebsiteimages 01/about4.webp"
import mpc7 from "../assets/rankridgecollegewebsiteimages 01/about6.webp"
import mpc8 from "../assets/rankridgecollegewebsiteimages 01/mpc3.webp"
import mpc9 from "../assets/rankridgecollegewebsiteimages 01/inter.webp"
import bipc from "../assets/rankridgecollegewebsiteimages 01/bipc.webp"
import bipc1 from "../assets/rankridgecollegewebsiteimages 01/bipc2.webp"
import bipc2 from "../assets/rankridgecollegewebsiteimages 01/bipc3.webp"
import bipc3 from "../assets/rankridgecollegewebsiteimages 01/bipc4.webp"
import bipc4 from "../assets/rankridgecollegewebsiteimages 01/inter3.webp"
import bipc5 from "../assets/rankridgecollegewebsiteimages 01/inter4.webp"
import bipc6 from "../assets/rankridgecollegewebsiteimages 01/inter6.webp"
import bipc7 from "../assets/rankridgecollegewebsiteimages 01/inter7.webp"
import bipc8 from "../assets/rankridgecollegewebsiteimages 01/inter8.webp"
import bipc9 from "../assets/rankridgecollegewebsiteimages 01/neet.webp"
import eapcet from "../assets/rankridgecollegewebsiteimages 01/eapcet1.webp"
import eapcet2 from "../assets/rankridgecollegewebsiteimages 01/eapcet.webp"
import eapcet3 from "../assets/rankridgecollegewebsiteimages 01/eapcet3.webp"
import eapcet4 from "../assets/rankridgecollegewebsiteimages 01/eapcet4.webp"
import eapcet5 from "../assets/rankridgecollegewebsiteimages 01/track3.webp"
import eapcet6 from "../assets/rankridgecollegewebsiteimages 01/track4.webp"
import eapcet7 from "../assets/rankridgecollegewebsiteimages 01/eapcet2.webp"
import eapcet8 from "../assets/rankridgecollegewebsiteimages 01/eapcet6.webp"
import longterm from "../assets/rankridgecollegewebsiteimages 01/longtermiit.webp"
import longterm2 from "../assets/rankridgecollegewebsiteimages 01/longtermiit2.webp"
import longterm3 from "../assets/rankridgecollegewebsiteimages 01/longtermiit.webp"
import longterm4 from "../assets/rankridgecollegewebsiteimages 01/longtermiit3.webp"
import longterm5 from "../assets/rankridgecollegewebsiteimages 01/longtermiit4.webp"
import longterm6 from "../assets/rankridgecollegewebsiteimages 01/longtermiit5.webp"
import longterm7 from "../assets/rankridgecollegewebsiteimages 01/eapcet6.webp"
import longterm8 from "../assets/rankridgecollegewebsiteimages 01/eapcet7.webp"
import longterm9 from "../assets/rankridgecollegewebsiteimages 01/eapcet8.webp"
import sports from "../assets/rankridgecollegewebsiteimages 01/welcome.webp"
import sports2 from "../assets/rankridgecollegewebsiteimages 01/sports.webp"
import sports3 from "../assets/rankridgecollegewebsiteimages 01/sports2.webp"
import sports4 from "../assets/rankridgecollegewebsiteimages 01/sports3.webp"
import sports5 from "../assets/rankridgecollegewebsiteimages 01/sports4.webp"
import sports6 from "../assets/rankridgecollegewebsiteimages 01/sports5.webp"
import sports7 from "../assets/rankridgecollegewebsiteimages 01/sports6.webp"
import sports8 from "../assets/rankridgecollegewebsiteimages 01/about9.webp"
import sports9 from "../assets/rankridgecollegewebsiteimages 01/about5.webp"

import bonalu1 from '../assets/bonalu/IMG_1051.webp'
import bonalu2 from '../assets/bonalu/IMG_1056.webp'
import bonalu3 from '../assets/bonalu/IMG_1059.webp'
import bonalu4 from '../assets/bonalu/IMG_1117.webp'
import bonalu5 from '../assets/bonalu/IMG_1118.webp'
import bonalu6 from '../assets/bonalu/IMG_1120.webp' 

import rankridgecollege from '../assets/rankridgeimages/rankridge-college.webp'
import rankridgefestival from '../assets/rankridgeimages/rankridge-festival.webp'
import rankridgefestivaltwo from '../assets/rankridgeimages/rankridge-festival-two.webp' 
import { homeImages } from "./data";

 




// const categories = ["MPC", "BiPC", "EAPCET", "Long Term", "Sports","Events"];
const categories = ["Events"];
const images = {
  MPC: [
   mpc,mpc2,mpc3,mpc4,mpc5,mpc6,mpc7,mpc8,mpc9
 
  ],
  BiPC: [
   bipc,bipc2,bipc3,bipc4,bipc5,bipc6,bipc7,bipc8,bipc9,bipc1
   
  ],
  EAPCET: [
   eapcet,eapcet2,eapcet3,eapcet4,eapcet5,eapcet6,eapcet7,eapcet8
    ],
  "Long Term": [
    longterm2,longterm3,longterm4,longterm5,longterm6,longterm7,longterm8,longterm9,longterm,
   ],
  Sports: [
    sports,sports2,sports3,sports4,sports5,sports6,sports7,sports8,sports9,
    ],
    Events:[...homeImages, bonalu3,bonalu4,bonalu2,bonalu6,rankridgecollege,rankridgefestival,rankridgefestivaltwo]
};

const Gallery = () => {
  const [selectedCategory, setSelectedCategory] = useState("Events");

  return (
    <div className="w-full px-4 py-10 bg-gray-50">
      <h2 className="text-3xl md:text-4xl font-bold text-center text-black mb-8">
        Rankridge Gallery
      </h2>

      {/* Tabs */}
      <div className="flex flex-wrap justify-center gap-4 mb-8">
        {categories.map((cat) => (
          <button
            key={cat}
            onClick={() => setSelectedCategory(cat)}
            className={`px-4 py-2 rounded-full font-medium transition duration-300 ${
              selectedCategory === cat
                ? "bg-[#018b81] text-white"
                : "bg-white border border-[#018b81] text-blue-700 hover:bg-blue-100"
            }`}
          >
            {cat}
          </button>
        ))}
      </div>

      {/* Gallery Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-6">
        {images[selectedCategory].map((src, idx) => (
          <div
            key={idx}
            className="w-full overflow-hidden rounded-xl shadow-md hover:scale-105 transition-transform duration-300" >
            <img
              src={src}
              alt={`${selectedCategory} ${idx + 1}`}
              className="w-full h-64 object-cover"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Gallery;
